import React, { useRef } from 'react'
import { useClickAway } from 'react-use'

import { RichTextEditor } from '../../../RichTextEditor'

export function Note ({
  value,
  isReadOnly,
  statuses,
  template,
  actions,
  selectedStatus,
  empty
}) {
  const editorRef = useRef()

  const { onStopEditing } = actions

  useClickAway(editorRef, event => {
    if (event?.target?.dataset?.clickAway === 'ignore') {
      return
    }

    onStopEditing?.()
  })

  return (
    <RichTextEditorWrapper>
      <RichTextEditor
        ref={editorRef}
        value={value}
        readOnly={isReadOnly}
        canEdit={!isReadOnly}
        template={template}
        actions={actions}
        statuses={statuses}
        empty={empty}
        selectedStatus={selectedStatus}
        onDoubleClick={() => {
          if (isReadOnly) {
            return
          }

          actions.onEdit?.()
        }}
      />
    </RichTextEditorWrapper>
  )
}

function RichTextEditorWrapper ({ children }) {
  return (
    <div className='flex relative justify-between flex-row h-full overflow-y-scroll'>
      {children}
    </div>
  )
}
